var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-start":""}},[_c('v-flex',[_c('v-alert',{attrs:{"type":"info","value":true}},[_vm._v(_vm._s(_vm.message))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }